( function () {
    'use strict';
    e.bootstrap = e.bootstrap || {};
    e.bootstrap.dropdown = {};
    e.bootstrap.dropdown.init = function () {
        e.bootstrap.dropdown.mega();
        e.bootstrap.dropdown.fixTouchClickIssue();
    };
    e.bootstrap.dropdown.fixTouchClickIssue = function () {
        jQuery( 'body' ).on( 'touchstart.dropdown', '.dropdown-menu', function ( event ) {
            event.stopPropagation();
        } ).on( 'click', '.dropdown-menu:not(.e-megamenu) a', function ( event ) {
            event.stopPropagation();
        } );
    };
    e.bootstrap.dropdown.mega = function () {
        jQuery( document ).on( 'click.dropdown.data-api', '[data-toggle="collapse"]', function ( event ) {
            if ( e.constant.jWindow.width() < 980 ) {
                event.preventDefault();
                //alert( 'preventDefault' );
            }
            event.stopPropagation();
        } );
    };
}() );
